<template>
    <div>
        <app-form v-if="!loading"
            v-bind:parentObject = "{
                data: this.formData,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                staffList: this.staffList,
                errMsg: this.errMsg,
                isEdit: this.editMode
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            />
        </div>    
    </div>
</template>

<script>
import moment from 'moment';
import KpiSettingForm from '../../../components/performancemanagement/targetsetting/FormSetting_Staff';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': KpiSettingForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('performancemanagement.kpisettingfor'),
            pageTitleValue: null,

            formData: {
                kpiexerid: this.$route.params.id,
                kpiexercode: null,
                kpiexerdesc: null,
                startdate: null,
                enddate: null,
                kpiexerstatusid: null,
                kpiexerstatus: null,
                wfroleid: null,
                wfrolecode: null,
                pending: null,
                open: null,
                locked: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            staffList: [],

            loading: true,
            errMsg: '',
            isErr:false,
            editMode: false 
        }
    },
        

    methods: {

        //load kpi exercise handler
        loadKpiExerciseHandler() {

            const vm = this;

            this.$store.dispatch('get', {url: "/kpiexercise/" + vm.formData.kpiexerid})
            .then((res) => {

            if (res.status == 200) {
                
                vm.formData = res.data.rec[0];

                vm.pageTitleValue = vm.formData.kpiexercode;

                if (vm.formData.startdate) {
                    vm.formData.startdate = moment(vm.formData.startdate).format('YYYY-MM-DD');
                }

                if (vm.formData.enddate) {
                    vm.formData.enddate = moment(vm.formData.enddate).format('YYYY-MM-DD');
                }
                vm.loading = !vm.loading;

            } else {
                vm.isErr = !vm.isErr;
            }
            })
            .catch((err) => {
                console.log(err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

        async loadGenerateStaff() {

            const vm = this;

            // Dispatch the post request with the payloads object
            await this.$store.dispatch('get', {url: "/kpiexercise/staff/" + vm.formData.kpiexerid})
            .then((res) => {

            if (res.status == 200) {

                for (let i = 0; i < res.data.rec.length; i++) {

                    if (res.data.rec[i].startdate) {
                        res.data.rec[i].startdate = moment(res.data.rec[i].startdate).format('YYYY-MM-DD');
                    }

                    if (res.data.rec[i].enddate) {
                        res.data.rec[i].enddate = moment(res.data.rec[i].enddate).format('YYYY-MM-DD');
                    }

                    if (res.data.rec[i].periodstartdate) {
                        res.data.rec[i].periodstartdate = moment(res.data.rec[i].periodstartdate).format('YYYY-MM-DD');
                    }

                    if (res.data.rec[i].periodenddate) {
                        res.data.rec[i].periodenddate = moment(res.data.rec[i].periodenddate).format('YYYY-MM-DD');
                    }

                    if (res.data.rec[i].createdate) {
                        res.data.rec[i].createdate = moment(res.data.rec[i].createdate).format('YYYY-MM-DD');
                    }

                    if (res.data.rec[i].completedate) {
                        res.data.rec[i].completedate = moment(res.data.rec[i].completedate).format('YYYY-MM-DD');
                    }

                }

                vm.staffList = res.data.rec;

            } else {
                vm.isErr = !vm.isErr;
            }
            })
            .catch((err) => {
                console.log(err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });

        },
        
    },

    async created() {
        await this.loadGenerateStaff();
        this.loadKpiExerciseHandler();
    }
}

</script>